<template>
  <div>
    <datatable
      :title="`${$route.query.title} Comments`"
      :is_createable="true"
      @edit_click="editClick"
      @create="createComment"
      @delete="deleteComment"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'developer-interview-articles',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'content',
          value: 'content'
        },
        {
          name: 'article_id',
          value: 'article_id'
        },
        {
          name: 'response_to_comment_id',
          value: 'response_to_comment_id'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      axios.request({
        method: 'get',
        url: `http://64.225.73.88:9078/comments/?article_id=${this.$route.query.article_id}`
      }).then(response => {
        this.data = response.data
      })
    },
    editClick (data) {
      this.create({
        designator: 'developer-interview-article-comment-form',
        component_name: 'DeveloperInterviewArticleCommentForm',
        modal_title: data.title,
        article_id: this.$route.query.article_id,
        data
      })
    },
    createComment () {
      this.create({
        designator: 'developer-interview-article-comment-form',
        component_name: 'DeveloperInterviewArticleCommentForm',
        modal_title: 'Create new comment',
        article_id: this.$route.query.article_id,
        is_create: true
      })
    },
    deleteComment (data) {
      axios.request({
        method: 'delete',
        url: `http://64.225.73.88:9078/comments/${data.id}`
      }).then(response => {
        this.$utils.emit('show_toast', { text: 'נמחק בהצלחה' })
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
